module.exports = __webpack_public_path__ + "static/media/5.b8d753fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/5.jpg
// module id = 92
// module chunks = 0